/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Wrapped_Week_TickInputs */

const en_us2_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.n}`)
};

const pt_br2_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.n}`)
};

const es_419_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.n}`)
};

const pt_pt2_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.n}`)
};

const fr_fr2_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.n}`)
};

const de_de2_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.n}`)
};

const it_it2_wrapped_week_tick = /** @type {(inputs: Wrapped_Week_TickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`S${i?.n}`)
};

/**
* | output |
* | --- |
* | "W{n}" |
*
* @param {Wrapped_Week_TickInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_week_tick = /** @type {((inputs: Wrapped_Week_TickInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Week_TickInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_week_tick(inputs)
	if (locale === "es-419") return es_419_wrapped_week_tick(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_week_tick(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_week_tick(inputs)
	if (locale === "de-DE") return de_de2_wrapped_week_tick(inputs)
	if (locale === "it-IT") return it_it2_wrapped_week_tick(inputs)
	return en_us2_wrapped_week_tick(inputs)
});
export { wrapped_week_tick as "wrapped.week_tick" }